import { InvoiceDocumentType } from '@/app/invoicing/enums/InvoiceDocumentType';

export default function useGetInvoiceDocumentTypes(): string[] {
    return Object.values(InvoiceDocumentType);
}
